import { lifeEvent } from '../jsonEditor/lifeEventJsonEditorConfig.js';
import { versionConfig, regionConfig, languageConfig } from '../options.js';
export const lifeEvents = {
    type: 'life-events',
    contentType: 'lifeEvent',
    editor: 'json',
    editorTitle: { name: 'title', placeholder: 'title' },
    editorDescription: { name: 'description', label: 'Description' },
    editorConfig: lifeEvent,
    editorContext: 'content',
    supportContent: [],
    title: 'Life Event',
    plural: 'Life Events',
    endpoint: 'lifeEvents',
    version: versionConfig,
    listing: {
        type: 'grid',
        gridColumns: ['title'],
        gridCombineProperty: 'slug',
        gridContentType: 'life-events',
        gridDecode: ['title'],
        gridFilters: [],
        gridHasChildren: true,
        gridJoin: { properties: [] },
        gridSearch: [{ key: 'title', combine: true }],
        gridSupportContent: [],
    },
    queryProperties: [
        'id',
        'title',
        'slug',
        'status',
        'type',
        'client',
        'region',
        'language',
        'created',
        'modified',
        'categories',
    ],
    sidebar: {
        status: [
            {
                label: 'Status',
                name: 'status',
                input: 'select',
                options: [
                    { label: 'Draft', value: 'draft' },
                    { label: 'Pending', value: 'pending' },
                    { label: 'Publish', value: 'published' },
                ],
            },
        ],
        version: [
            { label: 'Slug', name: 'slug', input: 'text' },
            { label: 'Client', name: 'client', input: 'multiselect' },
            regionConfig,
            languageConfig,
        ],
        versioned: true,
        images: [
            { label: 'Featured Image', name: 'image' },
            { label: 'Thumbnail Image', name: 'thumbnail' },
            { label: 'V3 Featured Image', name: 'v3image' },
            { label: 'V3 Thumbnail Image', name: 'v3thumbnail' },
        ],
    },
    meta: [
        {
            label: 'Priority',
            name: 'priority',
            input: 'number',
            description: 'Please enter the content priority number with 100 being the highest and 0 being the lowest.',
        },
        {
            label: 'Exclude Client',
            name: 'exclude',
            input: 'multiselect',
            description: 'Add clients to prevent them from viewing this article.',
        },
        {
            label: 'Notes',
            name: 'notes',
            input: 'textarea',
            description: 'Document notes.',
        },
    ],
    validate: [],
};
//# sourceMappingURL=lifeEvents.js.map